/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from "axios";
import { config, configBlob, uncachedConfig } from "./api-config";
import { PATHS } from "./api-routes";
import { pca } from "./auth/authConfig";
import serializeJavascript from "serialize-javascript";

export const getAccessToken = async (): Promise<string | undefined> => {
  //eslint-disable-next-line scanjs-rules/identifier_sessionStorage
  const bearer = sessionStorage.getItem("AzureADBearer");
  if (bearer) return bearer;
  let account = pca.getActiveAccount();
  if (!account) {
    account = pca.getAllAccounts()[0];
  }

  if (account) {
    return pca
      .acquireTokenSilent({
        scopes: [
          "api://" + process.env.REACT_APP_API_CLIENT_ID + "/access_as_user",
        ],
        account: account,
      })
      .then((response) => {
        if (response) {
          return response.accessToken;
        }
      });
  }
};

const createHeaders = async () => ({
  Authorization: "Bearer " + (await getAccessToken()),
  accept: "text/plain",
});

export async function getWithAuth(
  routeParam: string,
  parameters: any,
  id1: string | null = null,
  id2: string | null = null
): Promise<any> {
  const reqConfig = config;
  let routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  routes = id2 != null ? routes.replace("idToReplace2", id2) : routes;
  reqConfig.params = parameters;
  return axios
    .get(routes, {
      ...reqConfig,
      headers: await createHeaders(),
    })
    .then((res) => res.data);
}

export async function getXLSXWithAuth(
  routeParam: string,
  parameters: any,
  id1: string | null = null,
  id2: string | null = null
): Promise<any> {
  const reqConfig = configBlob;
  let routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  routes = id2 != null ? routes.replace("idToReplace2", id2) : routes;
  reqConfig.responseType = "blob";
  reqConfig.params = parameters;
  return axios
    .get(routes, {
      ...reqConfig,
      headers: await createHeaders(),
    })
    .then((res) => res.data);
}

export async function getWithAuthHealth(
  routeParam: string,
  parameters: any,
  id1: string | null = null,
  id2: string | null = null
): Promise<any> {
  const reqConfig = config;
  let routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  routes = id2 != null ? routes.replace("idToReplace2", id2) : routes;
  reqConfig.params = parameters;
  return axios
    .get(routes, {
      ...reqConfig,
      headers: await createHeaders(),
      timeout: 5000,
    })
    .then((res) => res.data);
}

export async function getUncachedWithAuth(
  key: string,
  parameters: any
): Promise<any> {
  const reqConfig = uncachedConfig;
  reqConfig.params = parameters;
  return axios
    .get(PATHS[key], {
      ...reqConfig,
      headers: await createHeaders(),
    })
    .then((res) => res.data);
}

export async function postWithAuth(
  routeParam: string,
  parameters: any,
  body: any,
  id1: string | null = null,
  id2: string | null = null
): Promise<any> {
  const reqConfig = config;
  reqConfig.params = parameters;
  axios.defaults.headers.post["Content-Type"] = "application/json";
  let routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  routes = id2 != null ? routes.replace("idToReplace2", id2) : routes;
  return axios
    .post(routes, '"' + body + '"', {
      ...reqConfig,
      headers: await createHeaders(),
    })
    .then((res) => res.data);
}

export async function postJsonWithAuth(
  routeParam: string,
  parameters: any,
  body: any,
  id1: string | null = null
): Promise<any> {
  const reqConfig = config;
  reqConfig.params = parameters;
  axios.defaults.headers.post["Content-Type"] = "application/json";
  const routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  return axios
    .post(routes, serializeJavascript(body, { isJSON: true }), {
      ...reqConfig,
      headers: await createHeaders(),
    })
    .then((res) => res.data);
}

export async function putToS3(
  url: string,
  contentType: string,
  parameters: any,
  data: any
): Promise<any> {
  const reqConfig: AxiosRequestConfig = {};
  reqConfig.params = parameters;
  axios.defaults.headers.post["Content-Type"] = contentType;
  return axios.put(url, data, reqConfig).then((res) => res.data);
}

export async function putWithAuth(
  routeParam: string,
  parameters: any,
  body: any,
  id1: string | null = null,
  id2: string | null = null
): Promise<any> {
  const reqConfig = config;
  reqConfig.params = parameters;
  axios.defaults.headers.put["Content-Type"] = "application/json";
  let routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  routes = id2 != null ? routes.replace("idToReplace2", id2) : routes;
  return axios
    .put(routes, body, { ...reqConfig, headers: await createHeaders() })
    .then((res) => res.data);
}

export async function deleteWithAuth(
  routeParam: string,
  parameters: any,
  id1: string | null = null,
  id2: string | null = null
): Promise<any> {
  const reqConfig = config;
  reqConfig.params = parameters;
  let routes =
    id1 != null
      ? PATHS[routeParam].replace("idToReplace1", id1)
      : PATHS[routeParam];
  routes = id2 != null ? routes.replace("idToReplace2", id2) : routes;
  return axios
    .delete(routes, { ...reqConfig, headers: await createHeaders() })
    .then((res) => res.data);
}
/* eslint-enable security/detect-object-injection, @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
